import React from "react";
import { CreateOrEditScriptModule } from "./CreateOrEditScriptModule";
interface CreateScriptModulePageProps {
    spaceId: string;
}
export function CreateScriptModulePage({ spaceId }: CreateScriptModulePageProps) {
    return <CreateOrEditScriptModule spaceId={spaceId} create/>;
}
